import RaisedButton from 'components/RaisedButton/RaisedButton';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import tinycolor from 'tinycolor2';
import uploadSignedS3 from '../../../../util/uploadSignedS3';
import Spinner from '../Spinner/Spinner';
import ColorThief from './async-load/color-thief';
import styles from './UploadS3.css';

const generateFileName = (len = 32) => {
  const randomChars = '0123456789abcdefghijklmnopqrstuvwxyz';
  let rnd = '';
  for (let i = 1; i <= len; i += 1) {
    const rn = Math.floor(Math.random() * randomChars.length);
    rnd += randomChars.substring(rn, rn + 1);
  }
  return rnd;
};

export default class Upload extends Component {
  constructor(props) {
    super(props);
    if (typeof document !== 'undefined') {
      this.$script = require('scriptjs');
      this.$script([ColorThief], 'ColorThief');
    }
    const { label } = props;
    this.state = {
      label,
    };
  }

  onProgress(percent) {
    this.setState({
      label: (
        <span>
          {`${percent}%`}
          <Spinner className={styles.spinner} />
        </span>
      ),
    });
  }

  handleFileChange = async e => {
    const file = e.target.files?.[0];
    if (!file) return;

    const { token, fileName = generateFileName() } = this.props;
    const key = `${fileName}.png`;

    try {
      const params = new URLSearchParams({
        fileName: key,
        contentType: file.type || 'image/png',
      });
      const res = await fetch(`/api/sign-s3?${params}`, {
        credentials: 'include',
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) {
        throw new Error(`Sign failed: ${res.status}`);
      }
      const signData = await res.json();
      await uploadSignedS3(signData.signedUrl, file, percent => {
        if (percent != null) {
          this.onProgress(percent);
        }
      });
      this.onFinish(signData);
    } catch (err) {
      const { label } = this.props;
      this.setState({ label });
      console.error(err);
    } finally {
      e.target.value = '';
    }
  };

  onFinish(e) {
    const { label, onFileLoad } = this.props;
    try {
      if (typeof document !== 'undefined') {
        let src = `${e.url}?r=${new Date().getTime()}`;
        let it = 0;
        setTimeout(() => {
          this.$script.ready('ColorThief', () => {
            const img = new Image();
            img.crossOrigin = 'Anonymous';
            img.onerror = () => {
              if (it < 10) {
                it += 1;
                setTimeout(() => {
                  src = `${e.url}?r=${new Date().getTime()}`;
                  img.src = `${src}b`;
                }, 500);
              }
            };
            img.onload = () => {
              const palette = new window.ColorThief().getPalette(img, 8, 1);
              palette.forEach(([r, g, b]) => {
                const c = tinycolor({ r, g, b });
                const bright = c.getBrightness();
                console.log(
                  `%c rgb(${r}, ${g}, ${b}) brightness: ${bright} dark: ${c.isDark()}`,
                  `color: ${c.isDark() ? '#ffffff' : '#000000'}; background: rgb(${r},${g},${b})`,
                );
              });
              let dark;
              for (let i = 0; i < palette.length && typeof dark === 'undefined'; i += 1) {
                const [r, g, b] = palette[i];
                const c = tinycolor({ r, g, b });
                if (c.isDark()) {
                  dark = c;
                }
              }
              onFileLoad(e.url, dark ? dark.toHexString() : undefined);
              this.setState({ label });
            };
            img.src = `${src}b`;
          });
        }, 1500);
      }
    } catch (_err) {
      onFileLoad(e.url);
      this.setState({ label });
    }
    const xhr = new XMLHttpRequest();
    xhr.open('DELETE', e.deleteUrl, true);
    xhr.send();
  }

  render() {
    const { _onFileLoad, buttonControl, fileName = generateFileName(), ...rest } = this.props;
    const { label } = this.state;
    return (
      <div className={styles.Container}>
        {fileName && fileName !== 'null'
          ? React.createElement(
              buttonControl,
              {
                variant: 'outlined',
                containerElement: 'label',
                ...rest,
                label,
              },
              <input
                type="file"
                accept="image/*"
                className={styles.FileInput}
                onChange={this.handleFileChange}
              />,
            )
          : null}
      </div>
    );
  }
}

Upload.defaultProps = {
  onFileLoad: () => undefined,
  buttonControl: RaisedButton,
  fileName: generateFileName(),
};

Upload.propTypes = {
  label: PropTypes.string.isRequired,
  onFileLoad: PropTypes.func,
  buttonControl: PropTypes.func,
  token: PropTypes.string.isRequired,
  fileName: PropTypes.string,
};
